import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from ".././../config/api";
import { orderStatus } from "../../constants/commonConstants";
import { generateQueryParams } from "../../utils/generateQueryParams";

export const fetchUserOrderByRoomId = createAsyncThunk(
    "order/fetchUserOrderByItsRoomId",
    async (arg) => {                
        const response = await api.get(`order/user-orders/room/${arg?.roomId || 'roomid'}`);
        return response.data;
    }
);

export const fetchUserOrderById = createAsyncThunk(
  "order/fetchUserOrderByItsObjectId",
  async (arg) => {                
      const response = await api.get(`order/user-orders/${arg?.id || 'roomid'}`);
      return response.data;
  }
);

// Place Order
export const placeOrder = createAsyncThunk(
  "order/placeOrder",
  async (orderData) => {
    const response = await api.post("/order", orderData);
    return response.data;
  }
);

// request revision
export const requestRevision = createAsyncThunk(
  "order/requestRevision",
  async (revisionData) => {
    const response = await api.post("/order/request-revision", revisionData);
    return response.data;
  }
);

// accept order
export const acceptOrder = createAsyncThunk(
  "order/acceptOrder",
  async (acceptOrderData) => {
    const response = await api.post("/order/accept", acceptOrderData);
    return response.data;
  }
);

// User Orders
export const fetchUserOrders = createAsyncThunk(
  "order/fetchUserOrders",
  async (arg) => {
    const query = generateQueryParams(arg);

    // dely for testing
    // await new Promise((resolve) => setTimeout(resolve, 1000));

    const response = await api.get(
        `order/user-orders?${query}`
    );
    return response.data;
  }
);

// Get User Raised Complaint Orders
export const complaintOrders = createAsyncThunk(
  "order/complaintOrders",
  async (args) => {
    const query = generateQueryParams(args, {
      multipleOrderStatus: `${orderStatus.COMPLETED},${orderStatus.RESOLVED},${orderStatus.COMPLAINT_RAISED}`,
    });

    // dely for testing
    // await new Promise((resolve) => setTimeout(resolve, 1000));

    const response = await api.get(
      `order/user-orders?${query}`
     );
    return response.data;
  }
);

// Raise Complaint Order
export const raiseComplaintOrder = createAsyncThunk(
  "order/raiseComplaintOrder",
  async (complaintData) => {
    const response = await api.post("/order/complaint", complaintData);
    return response.data;
  }
);

// pay order with paypal
export const createPaypalCheckout = createAsyncThunk(
  "order/createPaypalCheckout",
  async (orderData) => {
      const response = await api.post("/order/paypal-checkout", orderData);

      return response.data;
    
  }
);

// pay order with the wallet
export const payOrderWithWallet = createAsyncThunk(
  "order/payOrderWithWallet",
  async (arg) => {
      const response = await api.patch(`/order/pay/${arg?.id || ''}`);
      return response.data;
  }
);

export const getUserStatics = createAsyncThunk(
  "order/userDashboardStatics",
  async () => {
    const response = await api.get("/order/current-user-orders/statics");
    return response.data;
  }
);